import React from 'react'

import { labelsStore } from 'sdc-i18n-stores'

import { Rates } from './rates'

export const Netto = () => <Rates caption={labelsStore.labelFor('planning.net')} />
